const maskName = (name) => {
  name = `${name}`.trim();
  // 이름이 2개 이상의 단어로 이루어져 있는 경우
  if (name.includes(" ")) {
    // 이름을 공백으로 분리
    const names = name.split(" ");
    // 성은 맨 뒤 단어로 판단
    const lastName = names[names.length - 1];
    // 나머지 이름에 대해 마스킹 처리
    const otherNames = names.slice(0, -1).map((n) => n.substring(0, Math.ceil(n.length / 2)) + "*".repeat(Math.floor(n.length / 2)));
    return [...otherNames, lastName].join(" ");
  }

  // 이름이 1개의 단어로 이루어져 있는 경우
  const length = name.length;
  if (length === 1) {
    return "*";
  } else if (length === 2) {
    return `${name[0]}*`;
  } else {
    return name[0] + "*".repeat(length - 2) + name[length - 1];
  }
}

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        label: '작성일',
        value: 'date',
        query: {'ss': 'startDate', 'ee': 'endDate'},
        options: {
          default: {sd: '', ed: ''},
        }
      },
      {
        'component': 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {hiddenList: ['재해일시', '발생형태', '작성일', '작성년도']}
      },
      {
        'component': 'search-year', label: '연도', value: 'year', query: {'y': 'year'},
        options: {
          default: new Date().getFullYear()
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let dateTarget = "created_at";
    let dateBegin = `${new Date().getFullYear()}-01-01`;
    let dateEnd = `${new Date().getFullYear()}-12-31`;
    if (search.year) {
      dateBegin = `${search.year}-01-01`;
      dateEnd = `${search.year}-12-31`;
    }
    //  검색일
    if (search.date) {
      if (search.date.startDate) dateBegin = search.date.startDate;
      if (search.date.endDate) dateEnd = search.date.endDate;
    }
    conditions.push({key: dateTarget, operator: '>=', value: dateBegin})
    conditions.push({key: dateTarget, operator: '<', value: new Date(dateEnd).addDays(1).format("yyyy-MM-dd")})


    //  검색조건
    const heads = list.getHead().map(e => {return {[e.name] : e.key}});
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "작성년도",
        "key": "body.stdInfo.date"
      },
      {
        "name": "부서",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "재해자",
        "key": "body.재해자정보.성명"
      },
      {
        "name": "재해일시",
        "key": "body.재해발생개요.발생일"
      },
      {
        "name": "고용형태",
        "key": "body.재해자정보.고용형태"
      },
      {
        "name": "수행업무",
        "key": "body.재해자정보.수행업무"
      },
      {
        "name": "작성일",
        "key": "body.created_at"
      },
      {
        "name": "상해종류",
        "key": "body.재해자정보.상해종류"
      },
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).stdInfo.date? func.getContent(value).stdInfo.date.split('-')[0] : '' // 작성년도

        case 1: return func.getContent(value).stdInfo.field_name // 부서
        case 2: return maskName(func.getContent(value).재해자정보.성명) // 재해자
        case 3: return `${func.getContent(value).재해발생개요.발생일}, ${func.getContent(value).재해발생개요.발생시간.slice(0,-3)}` // 재해일시
        case 4: return func.getContent(value).재해자정보.고용형태 // 고용형태
        case 5: return func.getContent(value).재해자정보.수행업무 // 수행업무
        case 6: return func.getCreatedDate(value.created_at) // 작성일
        case 7: return func.getContent(value).재해자정보.상해종류 // 수행업무
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
